var map = {
	"./default-desktop-arabic-no-content.png": "945e",
	"./default-desktop-arabic.png": "369e",
	"./default-desktop-english-no-content.png": "4231",
	"./default-desktop-english.png": "4d03",
	"./default-mobile-arabic-no-content.png": "722c",
	"./default-mobile-arabic.png": "6320",
	"./default-mobile-english-no-content.png": "0816",
	"./default-mobile-english.png": "b859",
	"./default-tablet-arabic-no-content.png": "cb6d",
	"./default-tablet-arabic.png": "27e0",
	"./default-tablet-english-no-content.png": "741e",
	"./default-tablet-english.png": "cf1d",
	"./inline-desktop-arabic.png": "77b1",
	"./inline-desktop-english.png": "cd2e",
	"./inline-mobile-arabic.png": "8c25",
	"./inline-mobile-english.png": "ff75",
	"./inline-tablet-arabic.png": "39a9",
	"./inline-tablet-english.png": "addf",
	"./stories-desktop-arabic.png": "2e30",
	"./stories-desktop-english.png": "4c955",
	"./stories-mobile-arabic.png": "7525",
	"./stories-mobile-english.png": "7c71",
	"./stories-tablet-arabic.png": "1cda",
	"./stories-tablet-english.png": "9f46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f559b";